module.exports = __webpack_public_path__ + "media/assets/images/flags/gn-f893d8ca342bb401a5b1c979db1b5fdc.svg";